import actions from './users2/actions';
import getters from './users2/getters';
import mutations from './users2/mutations';

export const users2 = {
  namespaced: true,
  state: {
    accountTypeOptions: [],
    accountTypeRelations: [],
    activeUser: {},
    blankUser: {
      firstName: '',
      lastName: '',
      userId: '',
      email: '',
      accountType: '',
      countryCode: 'US',
      phone: '',
      phoneType: '',
      emailInvoice: true,
      smsEnabled: true,
      role: {
        userId: '',
        accountType: '',
        groupsWithSubGroups: [],
        minimumAccess: {},
        minimumAccessPending: {},
        paperlessSelectionRequired: false,
        pendingGroupsWithSubGroups: [],
        securityChanged: false,
        subGroupAccess: [],
        subGroupAccessPending: [],
        userRole: null,
        userType: null,
      },
      transactionHistory: [],
    },
    cloneAcls: [],
    deactivating: false,
    defaultAccess: {
      claimsAllowed: false,
      createGroupUsersAllowed: false,
      enrollmentAllowed: false,
      memberMaintenanceAllowed: false,
      memberSearchAllowed: true,
      primaryContact: false,
      viewInvoicesAllowed: false,
    },
    groupToAddTo: null,
    groupToAddUsersTo: null,
    groupsToAdd: [],
    historyLoading: false,
    transactionHistory: [],
    loading: false,
    newUserACLs: [],
    perms: [
      { name: 'memberSearchAllowed', text: 'Member View'},
      { name: 'memberMaintenanceAllowed', text: 'Member Management'},
      { name: 'enrollmentAllowed', text: 'Enrollment Report'},
      { name: 'claimsAllowed', text: 'Claims Invoice'},
      { name: 'viewInvoicesAllowed', text: 'Billing'},
      { name: 'createGroupUsersAllowed', text: 'Admin Management'},
    ],
    searchGroups: [],
    userIdsToBeAdded: [],
  },
  actions,
  getters,
  mutations,
}